import { useTranslation } from "react-i18next";
import sendImg from "../assets/images/send-code.png";
import { Link } from "react-router-dom";

const ForgotSend = ({ email }) => {
  const { t } = useTranslation();

  return (
    <div className="forgot-password">
        <img src={sendImg} alt=""/>
      <h1>{t("Request sent successfully")}</h1>
      <p className="paragraph">
        {t(
          "We have sent a confirmation email to "
        )} <span>{ email }</span>{t(
            " Please check your email."
          )}
      </p>
      <Link style={{textDecoration: "none"}} className="form-default__submit mt-40" to="/sign-in">{t("Back to Log in")}</Link>
    </div>
  );
};
export default ForgotSend;